/* ProductCompatibilitySummary.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Link } from '@atlassian/mpac-primitives';
import { UrlUtils } from '@atlassian/mpac-utils';
import React from 'react';
import { getProductCompatibilitySummary } from '../AppListing.utils';
import MultipleProductCompatibilitySummary from './MultipleProductCompatibilitySummary';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _ = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const preTextStyle = null;
const ProductCompatibilitySummary = props => {
  const {
    cloudCompatibleProducts,
    serverCompatibleProducts,
    dataCenterCompatibleProducts,
    totalVersionCount,
    versionHistoryUrl
  } = props;
  const allCompatibilities = [...cloudCompatibleProducts, ...serverCompatibleProducts, ...dataCenterCompatibleProducts];
  const compatibleWithMultipleProducts = new Set(allCompatibilities.map(product => product.id)).size > 1;
  if (compatibleWithMultipleProducts) {
    return /*#__PURE__*/_jsx(MultipleProductCompatibilitySummary, {
      compatibleProducts: allCompatibilities,
      totalVersionCount: totalVersionCount,
      versionHistoryUrl: versionHistoryUrl
    });
  }
  const summary = getProductCompatibilitySummary(allCompatibilities);
  const showMoreVersionsLink = totalVersionCount > 1;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_]
      }), /*#__PURE__*/_jsx("span", {
        className: ax(["_syaz1gjq"]),
        children: "works with"
      })]
    }), " ", summary, showMoreVersionsLink && /*#__PURE__*/_jsxs(_Fragment, {
      children: [' ', /*#__PURE__*/_jsx(Link, {
        size: "small",
        href: UrlUtils.removeQueryParamsFromUrl(versionHistoryUrl),
        title: "View version history for more details",
        children: "and more"
      })]
    })]
  });
};
export default ProductCompatibilitySummary;